import React from "react";
import { Typography } from "@mui/material";
import AcxInputWithChips from "components/UI/AcxInputWithChips";
import ControlsContainer from "./ControlsContainer";

interface HotWordsControlsProps {
    hotWords: string[];
    setHotWords: (words: string[]) => void;
    hotWordsIsEnabled: boolean;
    setHotWordsIsEnabled: (enabled: boolean) => void;
    isViewOnly: boolean;
}

const HotWordsControls: React.FC<HotWordsControlsProps> = ({
    hotWords,
    setHotWords,
    hotWordsIsEnabled,
    setHotWordsIsEnabled,
    isViewOnly,
}) => {
    const heading = "Custom Vocabulary";
    const description = `Add specific words or phrases you'd like the transcription
                    system to recognize and transcribe accurately for this
                    customer. This is especially helpful for brand names,
                    product terms, uncommon spellings, or industry-specific
                    language.`;

    return (
        <ControlsContainer
            heading={heading}
            description={description}
            isEnabled={hotWordsIsEnabled}
            setIsEnabled={setHotWordsIsEnabled}
            maxHeight={250}
            expandLabel="Expand"
            collapseLabel="Collapse"
            isViewOnly={isViewOnly}
        >
            <Typography>
                Enter words or phrases to prioritize in transcription accuracy:
            </Typography>

            <AcxInputWithChips
                values={hotWords}
                setValues={(values) => setHotWords(values)}
            />
        </ControlsContainer>
    );
};

export default HotWordsControls;
